export default __webpack_public_path__ + "static/0057-a7252b50927455edbdd01422329c558e.png";